import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ba39b5a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba39b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba39b5a')) {
      api.createRecord('4ba39b5a', component.options)
    } else {
      api.reload('4ba39b5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ba39b5a&scoped=true", function () {
      api.rerender('4ba39b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/entry/inform/index.vue"
export default component.exports